/**
 * Config flags slice
 */
export const configSlice = {
    applyingStoredConfig: false,
    debugOn: false,
    sparringSummary: null, // e.g. "Against 1800-2000 blitz, rapid lichess"
};
